module.exports = __webpack_public_path__ + "img/partner-tsn.c1243629.png";